import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
import moment from 'moment'

import postDetailStyles from './postDetail.module.css'

class EventTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulEvent')
    const siteData = get(this.props, 'data.site.siteMetadata')

    // console.log()

    const rawPd = get(this.props, 'data.contentfulEvent.date')
    const eventDate = moment(rawPd, 'DD MMMM YYYY').format('YYYY-MM-DD')
    // const dEventDate = moment(rawPd, 'DD MMMM YYYY').format('DD MMMM YYYY')
    const rawEd = get(this.props, 'data.contentfulEvent.endDate')
    const endDate = moment(rawEd, 'DD MMMM YYYY').format('YYYY-MM-DD')
    // const dEndDate = moment(rawEd, 'DD MMMM YYYY').format('DD MMMM YYYY')


    return (
      <div style={{ background: '#fff' }}  className="page-content">
        <Helmet title={`${post.title} | ${siteData.title}`}>
          <link rel="canonical" href={`${siteData.siteUrl}/event/${post.slug}`} />
          <meta name="description" content={`${post.excerpt}`} />
          <meta name="title" content={`${post.title} | ${siteData.title}`} />

          <meta property="og:title" content={`${post.title} | ${siteData.title}`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/event/${post.slug}`} />
          <meta property="og:description" content={`${post.excerpt}`}  />
          <meta property="og:image" content={`${post.thumbnail.sizes.src}`} />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="article" />

          <meta property="article:published_time" content={`${eventDate}`} />
          <meta property="article:author" content={`Youcat Indonesia`} />

          <script type='application/ld+json'>
            {
              `"@context": "https://www.schema.org",
              "@type": "Event",
              "name": ${post.title},
              "url": ${siteData.siteUrl}/event/${siteData.slug},
              "description": ${post.excerpt},
              "startDate": ${eventDate},
              "endDate": ${endDate},
              "location": ${post.venue}`
            }
          </script>

        </Helmet>



        <div className={`grid-x grid-padding-x grid-padding-y`}>
          <div className={`program-image post-image cell medium-shrink ${postDetailStyles.postThumbWrapper}`}>
            <Img className={postDetailStyles.postThumb} alt={post.title} sizes={post.thumbnail.sizes} />
          </div>
          <div className="cell medium-auto">
            <h1 className={postDetailStyles.postTitle}>{post.title}</h1>
            <div className={postDetailStyles.postContent}
              dangerouslySetInnerHTML={{
                __html: post.body.childMarkdownRemark.html,
              }}
            />
            <div className="event-info">
              <table className={postDetailStyles.table}>
                <tbody>
                  <tr>
                    <th>
                      Tanggal
                    </th>
                    <td>
                { eventDate ? (
                      `${rawPd}` 
                ): '' }
                { endDate ? (
                      ` - ${rawEd}` 
                ): '' }
                    </td>
                  </tr>
                { post.venue ? (
                  <tr>
                    <th>
                      Lokasi
                    </th>
                    <td>
                      { `${post.venue}` }
                    </td>
                  </tr>
                ): '' }
                { post.registerUrl ? (
                  <tr>
                    <th>
                      Registrasi
                    </th>
                    <td>
                      <a href={ `${post.registerUrl}` }>Ketuk Disini</a>
                    </td>
                  </tr>
                ): '' }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventTemplate

export const pageQuery = graphql`
  query EventBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
    contentfulEvent(slug: { eq: $slug }) {
      title
      slug
      thumbnail {
        sizes(maxWidth: 1080, background: "rgb:000000") {
          ...GatsbyContentfulSizes_withWebp
        }
      }
      body {
      childMarkdownRemark {
          html
        }
      }
      excerpt
      venue
      date(formatString: "DD MMMM YYYY")
      endDate(formatString: "DD MMMM YYYY")
      images {
        sizes(maxWidth: 1080, background: "rgb:000000") {
          ...GatsbyContentfulSizes_withWebp
        }
      }
      registerUrl
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/event-post.js